<script setup>
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import { onMounted, watch } from 'vue'
import { useAuthStore } from '@/stores/auth.js'
import { wsMessages } from '@/services/wsMessages.js'
import { wsTasks } from '@/services/wsTasks.js'
import { wsNotifications } from '@/services/wsNotifications.js'
import { wsReminders } from '@/services/wsReminders.js'
import { setNotificationToastCallback } from '@/stores/notifications.js'
import { setReminderToastCallback } from '@/stores/reminders.js'
import { useRemindersStore } from '@/stores/reminders.js'
import { useToast } from 'primevue/usetoast'

const auth = useAuthStore()
const toast = useToast()
const remindersStore = useRemindersStore()

const RU_TITLES = {
  work: 'Работа',
  facility: 'Объект',
  contract: 'Договор',
  customer: 'Клиент',
}

// Настраиваем callback для показа toast уведомлений через store
setNotificationToastCallback((notification) => {
  toast.add({
    severity: 'info',
    summary: notification.title,
    detail: notification.text,
    life: 5000,
    group: 'notifications'
  })
})

// Настраиваем callback для показа toast напоминаний через store
setReminderToastCallback((reminder) => {
  const type = String(reminder.entity_type || '').toLowerCase()
  const ruType = RU_TITLES[type] || reminder.entity_type || 'Сущность'
  const title = reminder.entity_short_name || (RU_TITLES[type] || 'Сущность')
  const id = reminder.source_id ?? reminder.id

  toast.add({
    group: 'bc',
    severity: 'info',
    summary: ruType,
    detail: reminder.text || '',
    sticky: true,
    closable: true,
    data: { id, title },
  })
})

// Обработчик закрытия toast напоминаний (для ACK)
const onToastClose = (payload) => {
  const id = payload?.message?.data?.id
  if (id) remindersStore.acknowledge(id).catch(() => {})
}

// Первичное подключение после загрузки приложения, если токен уже есть
onMounted(() => {
  if (auth.access || localStorage.getItem('auth_access')) {
    wsMessages.connect()
    wsTasks.connect()
    wsNotifications.connect()
    wsReminders.connect()
  }
})

// При смене access-токена: закрываем старые сокеты и переподключаем при наличии токена
watch(() => auth.access, (val) => {
  try { wsMessages.close() } catch {}
  try { wsTasks.close() } catch {}
  try { wsNotifications.close() } catch {}
  try { wsReminders.close() } catch {}
  if (val) {
    wsMessages.connect()
    wsTasks.connect()
    wsNotifications.connect()
    wsReminders.connect()
  }
})
</script>

<template>
  <router-view />
  <Toast group="bc" @close="onToastClose" severity="warn">
    <template #message="slotProps">
      <div class="flex flex-col items-start flex-auto">
        <div class="flex items-center gap-2">
          <span class="font-bold">{{ slotProps.message.summary }}</span>
        </div>
        <div class="font-medium text-lg my-4">{{ slotProps.message?.data?.title || '...' }}</div>
        <div class="p-toast-detail">{{ slotProps.message.detail }}</div>
      </div>
    </template>
  </Toast>
  <Toast group="notifications" position="top-right" />
  <Toast />
  <ConfirmDialog />
</template>
<style>
.p-popover::before,
.p-popover::after {
  display: none !important;
}
.p-popover {
    transform: translateY(10px) !important;
}

</style>